import { darkColors } from '@tryhackme/thm-ui-components';
import { ReactComponent as Target } from 'src/images/svgs/reprofiling/target.svg';
import { StyledContainer, StyledContentPanel, StyledGreeting, StyledMainContent, StyledMainText, StyledMainTextRow, StyledMainTextSection, StyledStarIcon, StyledSubtext, StyledTopPanel } from './reprofiling-start.styles';
export const ReprofilingStart = ({
  name = '',
  theme,
  footer
}: {
  name?: string;
  theme: string;
  footer: React.ReactNode;
}) => {
  const isDark = theme === 'dark';
  const formatName = (name: string) => {
    if (!name) return '';
    return name.split('.').map(part => part.charAt(0).toUpperCase() + part.slice(1)).join('.');
  };
  const formattedName = formatName(name);
  return <StyledContainer data-sentry-element="StyledContainer" data-sentry-component="ReprofilingStart" data-sentry-source-file="reprofiling-start.tsx">
      <StyledTopPanel data-sentry-element="StyledTopPanel" data-sentry-source-file="reprofiling-start.tsx" />
      <StyledStarIcon data-sentry-element="StyledStarIcon" data-sentry-source-file="reprofiling-start.tsx" />
      <StyledContentPanel data-sentry-element="StyledContentPanel" data-sentry-source-file="reprofiling-start.tsx">
        <StyledMainContent data-sentry-element="StyledMainContent" data-sentry-source-file="reprofiling-start.tsx">
          <StyledGreeting $isDarkMode={isDark} data-sentry-element="StyledGreeting" data-sentry-source-file="reprofiling-start.tsx">
            Hey, <span>{formattedName}</span>!
          </StyledGreeting>
          <StyledMainTextSection data-sentry-element="StyledMainTextSection" data-sentry-source-file="reprofiling-start.tsx">
            <StyledMainTextRow data-sentry-element="StyledMainTextRow" data-sentry-source-file="reprofiling-start.tsx">
              <Target fill={isDark ? darkColors.grey[400] : darkColors.secondary.lighter} data-sentry-element="Target" data-sentry-source-file="reprofiling-start.tsx" />
              <StyledMainText $isDarkMode={isDark} data-sentry-element="StyledMainText" data-sentry-source-file="reprofiling-start.tsx">
                Zero In on <span>Your Next Steps</span>
              </StyledMainText>
            </StyledMainTextRow>
            <StyledSubtext data-sentry-element="StyledSubtext" data-sentry-source-file="reprofiling-start.tsx">
              Keep your info fresh to receive spot-on recommendations and accelerate your progress.
            </StyledSubtext>
          </StyledMainTextSection>
        </StyledMainContent>
        {footer}
      </StyledContentPanel>
    </StyledContainer>;
};